
<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{$t('search.title')}}</h3>
          </div>

          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  type="text"
                  v-on:keyup.enter="onSearchCustomerCompany"
                  class="form-control"
                  :placeholder="$t('customer.firstname')"
                  v-model="search.name"
                />
              </div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  v-on:keyup.enter="onSearchCustomerCompany"
                  type="text"
                  class="form-control"
                  :placeholder="$t('customer.company_tax_code')"
                  v-model="search.tax_code"
                />
              </div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  v-on:keyup.enter="onSearchCustomerCompany"
                  type="text"
                  class="form-control"
                  :placeholder="$t('customer.company_address')"
                  v-model="search.address"
                />
              </div>
            </div>
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  type="text"
                  v-on:keyup.enter="onSearchCustomerCompany"
                  class="form-control"
                  :placeholder="$t('customer.legal_representation')"
                  v-model="search.legal_representation"
                />
              </div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  v-on:keyup.enter="onSearchCustomerCompany"
                  type="text"
                  class="form-control"
                  :placeholder="$t('customer.company_phone')"
                  v-model="search.mobile_phone"
                />
              </div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  v-on:keyup.enter="onSearchCustomerCompany"
                  type="text"
                  class="form-control"
                  :placeholder="$t('customer.company_email')"
                  v-model="search.email"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearchCustomerCompany"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{$t('search.search_button')}}
                </button>
              </div>
            </div>
          </div>

        </div>

        <div class="box box-primary" style="width:100%">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{$t('customer.customer_company_list')}}</b>
              <lte-button
                style="float:right;background-color:white !important;"
                type="btn btn-default"
                right_icon="fa fa-plus"
                @click="addNewCustomerCompany($event)"
              >{{$t('user.addnew')}}</lte-button>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-sm-12 table-responsive no-padding">
                  <b-table :items="customerCompanyList" :fields="customerCompanyFields" class="mt-3" outlined>
                    <template #head()="scope">
                      <div>{{ $t(scope.label) }}</div>
                    </template>
                    <template slot="target" slot-scope="row">
                      <a :href="row.item.url" target="_blank" :id="`apartment_reservation_target_${row.item.id}`">{{row.item.target}}</a>
                      <tooltip :text="row.item.url" :target="`#apartment_reservation_target_${row.item.id}`"/>
                    </template>
                    <template slot="actions" slot-scope="row">
                      <template>
                        <div class="btn-group">
                          <button type="button" class="btn btn-danger dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                            <i class="fa fa-fw fa-ellipsis-h"></i>
                          </button>
                          <ul class="dropdown-menu hide-scroll-bar" style="min-width: 50px;max-height: 80px;">
                            <li>
                                <button
                                class="btn btn-primary btn-sm"
                                style="margin-left: 6px;"
                                @click="editCustomerCompany(row)"
                                >
                                <i class="glyphicon glyphicon-edit"></i>
                                </button>
                            </li>
                            <li>
                                <button
                                class="btn btn-danger btn-sm"
                                style="margin-left: 6px;"
                                @click="deleteCustomerCompany(row)"
                                >
                                <i class="glyphicon glyphicon-remove"></i>
                                </button>
                            </li>
                          </ul>
                      </div>
                      </template>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <lte-modal-partment-leaseback-company
            ref="modalApartmentLeaseBackCompany"
            @reload_leaseback_company="reloadLeaseBackCompany"
        ></lte-modal-partment-leaseback-company>
        <!-- Modal Confirm Delete Customer Company -->
        <div class="modal fade" id="modal-confirm-delete-customer-company">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{$t('customer.confirm_delete_leaseback_company')}}</h4>
              </div>
              <div class="modal-body">
                <p>{{$t('customer.sure_confirm_delete_leaseback_company')}}</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default pull-left" data-dismiss="modal" style="background-color: #f29911;border-color: #f29911;color:#fff">{{$t('common.back')}}</button>
                <button type="button" class="btn btn-primary btn-green" @click="onDelete">{{$t('common.confirm')}}</button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
        <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
      </row>
    </div>
  </div>
</template>

<script>
import LTEModalApartmentLeasebackCompany from "@/components/LTEModalApartmentLeasebackCompany";
import LTEButton from "@/components/LTEButton.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import { mapGetters, mapActions } from 'vuex';
// import utils from '@/lib/utils'

export default {
  name: "LeaseBackCustomerCompanyList",
  data() {
    return {
        customerCompanyList: [],
        customerCompanyFields: [
            { key: 'name', label: 'customer.firstname', sortable: true, class: 'text-center' },
            { key: 'tax_code', label: 'customer.company_tax_code', sortable: true, class: 'text-center' },
            { key: 'address', label: 'customer.company_address', sortable: true, class: 'text-center' },
            { key: 'legal_representation', label: 'customer.legal_representation', sortable: true, class: 'text-center'},
            { key: 'mobile_phone', label: 'customer.company_phone', sortable: true, class: 'text-center'},
            { key: 'email', label: 'customer.company_email', sortable: true, class: 'text-center' },
            { key: "actions", label: "common.action", class: 'text-center' }
        ],
        search: {
            name: '',
            tax_code: '',
            address: '',
            legal_representation: '',
            mobile_phone: '',
            email: '',
        },
        customer_company_id: 0,
        isLoading: false
    }
  },
  watch: {
  },
  computed: {
    ...mapGetters([
        "GET_SNACK_BAR"
    ]),
  },
  methods: {
    onDelete: function() {
      $("#modal-confirm-delete-customer-company").modal("hide")
      this.DELETE_LEASEBACK_COMPANY({id: this.customer_company_id}).then(
        function(res) {
          this.getLeaseBackCompany();
          this.SUCCESS_TOAST()
        }.bind(this)
      ).catch(
        function(error) {
          this.ON_SHOW_TOAST({
            message: error,
            styleType: "danger"
          })
        }.bind(this)
      )
    },
    deleteCustomerCompany: function(rowItem) {
      this.customer_company_id = rowItem.item.id
      $("#modal-confirm-delete-customer-company").modal("show")
    },
    editCustomerCompany: function(rowItem) {
      let customer_company_id = rowItem.item.id
      this.$refs.modalApartmentLeaseBackCompany.showModalAddCompany(customer_company_id);
    },
    onSearchCustomerCompany: function() {
        let data = {
            params: {
                'name': this.search.name,
                'tax_code': this.search.tax_code,
                'address': this.search.address,
                'legal_representation': this.search.legal_representation,
                'mobile_phone': this.search.mobile_phone,
                'email': this.search.email
            }
        }
        this.isLoading = true
        this.GET_LEASEBACK_COMPANY_LIST(data).then(
            function(res) {
                let data = res.data
                this.customerCompanyList = []
                for (let i = 0, size = data.length; i < size; i++) {
                    let customerCompanyObject = {
                      'id': data[i].id,
                      'name': data[i].name,
                      'tax_code': data[i].tax_code,
                      'address': data[i].address,
                      'legal_representation': data[i].representative_name,
                      'mobile_phone': data[i].phone,
                      'email': data[i].email
                    }
                    this.customerCompanyList.push(customerCompanyObject)
                }
                this.isLoading = false
            }.bind(this)
        ).catch(
            function(error) {
                this.isLoading = false
            }.bind(this)
        )
    },
    reloadLeaseBackCompany: function() {
      this.getLeaseBackCompany();
    },
    getLeaseBackCompany: function() {
        this.isLoading = true
        this.GET_LEASEBACK_COMPANY_LIST().then(
            function(res) {
                this.customerCompanyList = []
                let data = res.data
                for (let i = 0, size = data.length; i < size; i++) {
                    let customerCompanyObject = {
                      'id': data[i].id,
                      'name': data[i].name,
                      'tax_code': data[i].tax_code,
                      'address': data[i].address,
                      'legal_representation': data[i].representative_name,
                      'mobile_phone': data[i].phone,
                      'email': data[i].email
                    }
                    this.customerCompanyList.push(customerCompanyObject)
                }
                this.isLoading = false
            }.bind(this)
        ).catch(
            function(error) {
                this.isLoading = false
            }.bind(this)
        )
    },
    addNewCustomerCompany: function() {
      this.$refs.modalApartmentLeaseBackCompany.showModalAddCompany(null);
    },
    ...mapActions([
      "GET_LEASEBACK_COMPANY_LIST",
      "DELETE_LEASEBACK_COMPANY",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ERROR_TOAST"
    ]),
  },
  mounted() {
    this.getLeaseBackCompany()
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    loading: Loading,
    "lte-button": LTEButton,
    "lte-modal-partment-leaseback-company": LTEModalApartmentLeasebackCompany,
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Apartment/LeaseBackCustomerCompanyList.vue